import RecordsPage from "../records/RecordsPage";

export default function Roles() {
  return <RecordsPage featureKey="roles" />;
}
